import {
  SimpleLineChart,
  StackedBarChart,
  WaterfallChart,
} from '../../components/charts';
import type { CategoryData } from '../../components/charts/WaterfallChart';
import type { SimpleLineChartDataPoint } from '../../components/charts/SimpleLineChart';
import { ChartCard, LoadingState } from '../../components/ui';
import { DEFAULT_LINE_COLOR, type StatementType } from './financialStatements.config';

interface StatementBottomChartProps {
  statementType: StatementType;
  currencyCode: string;
  bottomTitle: string;
  bottomLineChartData: SimpleLineChartDataPoint[];
  bottomLineChartLoading: boolean;
  liabilitiesWaterfallData: CategoryData[];
  balanceWaterfallLoading: boolean;
  incomeOpExChartData: {
    xLabels: string[];
    stacks: Parameters<typeof StackedBarChart>[0]['stacks'];
  } | null;
  filteredStatementData: Map<number, Map<string, number>> | null;
}

export function StatementBottomChart({
  statementType,
  currencyCode,
  bottomTitle,
  bottomLineChartData,
  bottomLineChartLoading,
  liabilitiesWaterfallData,
  balanceWaterfallLoading,
  incomeOpExChartData,
  filteredStatementData,
}: StatementBottomChartProps) {
  return (
    <ChartCard title={bottomTitle} className="fs-layout__bottom-chart fs-chart-card">
      {statementType === 'balance' ? (
        balanceWaterfallLoading ? (
          <LoadingState message="Loading equity data…" />
        ) : (
          <WaterfallChart
            data={liabilitiesWaterfallData}
            title=""
            height="100%"
            width="100%"
            currencyCode={currencyCode}
            className="fs-chart-panel"
          />
        )
      ) : statementType === 'income' && incomeOpExChartData ? (
        <StackedBarChart
          xLabels={incomeOpExChartData.xLabels}
          stacks={incomeOpExChartData.stacks}
          xAxisLabel=""
          yAxisLabel=""
          maxXTicks={8}
          height="100%"
          width="100%"
          loading={filteredStatementData === null}
          currencyCode={currencyCode}
          barmode="stack"
          className="fs-chart-panel"
        />
      ) : (
        <SimpleLineChart
          data={bottomLineChartData}
          title=""
          xAxisLabel="Date"
          yAxisLabel={bottomTitle}
          lineColor={DEFAULT_LINE_COLOR}
          showMarkers
          showGrid
          height="100%"
          width="100%"
          loading={bottomLineChartLoading}
          markerSize={4}
          currencyCode={currencyCode}
          className="fs-chart-panel"
        />
      )}
    </ChartCard>
  );
}
